export default "__VITE_ASSET__BtPN1Q8g__"